import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95bede8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  name: "viewport",
  content: "width=device-width, initial-scale=1, user-scalable=0"
}, null, -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "article-info" }
const _hoisted_5 = { class: "pub-time info" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-rili",
  style: {"margin-right":"0.5rem"}
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-text" }, "发表于 ", -1))
const _hoisted_8 = { class: "words info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-zishu",
  style: {"margin-right":"0.5rem"}
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-text" }, "字数统计: ", -1))
const _hoisted_11 = { class: "read-time info" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-shizhong",
  style: {"margin-right":"0.5rem"}
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-text" }, "阅读时长(分钟) ≈ ", -1))
const _hoisted_14 = {
  key: 0,
  class: "iconfont icon-tuding is-top"
}
const _hoisted_15 = { class: "summary" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "read-btn-container" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "split-line" }, null, -1))
const _hoisted_20 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.articleList, (article) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "article-container",
        key: article.id
      }, [
        _createElementVNode("div", {
          class: "article-title",
          onClick: ($event: any) => ($setup.readArticle(article.url))
        }, _toDisplayString(article.title), 9, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(article.createdAt), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(article.words), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createTextVNode(_toDisplayString(article.readingTime), 1)
          ]),
          (article.top === '1')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (article.summary == null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, " 暂无简介 "))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(article.summary), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", {
            class: "read-btn",
            onClick: ($event: any) => ($setup.readArticle(article.url))
          }, "阅读全文", 8, _hoisted_18)
        ]),
        _hoisted_19
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_v_pagination, {
        modelValue: $setup.page,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (($setup.page) = $event)),
          $setup.loadArticle
        ],
        pages: $setup.pageCount,
        "range-size": 1,
        "active-color": "#d0d0d0"
      }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
    ])
  ]))
}